import { FunctionComponent, ReactNode } from 'react';
import { useSelector } from '@cbridge-utils/react-redux';
import { isUserSettingsReadySelector } from '../../_selectors/isUserSettingsReady.selector';

/**
 * Blocks rendering until the user's UI settings are resolved (GET /profile/settings is
 * requested right after login), so pages that read layout settings never paint with
 * defaults first. Nest inside AuthProtection. A failed request also opens the gate —
 * the app must not stay blocked because of a settings error.
 */
export const UserSettingsGate: FunctionComponent<{ children?: ReactNode }> = ({ children }) => {
  const isReady = useSelector(isUserSettingsReadySelector);

  if (isReady) {
    return children;
  }

  return null;
};
